import { render } from "./FavStarButton.vue?vue&type=template&id=65746480&scoped=true"
import script from "./FavStarButton.vue?vue&type=script&lang=js"
export * from "./FavStarButton.vue?vue&type=script&lang=js"

import "./FavStarButton.vue?vue&type=style&index=0&id=65746480&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65746480"]])

export default __exports__